// src/components/ResumeBuilder/forms/SkillsForm.jsx
import { useContext } from "react";
import {
  Box,
  Card,
  Grid,
  TextField,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { FieldArray, Formik, Form } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import GradientButton from "../Button";
import { ResumeContext } from "../../ResumeContext";
import { saveResumeData } from "../../api/resumeapi";
import BasicInfoSkeleton from "./skeletonLoader";
import { SkillsSchema } from "./resumevalidation";

export default function SkillsForm({ onNext }) {
  const { data, setData, loading } = useContext(ResumeContext);

  //  Skeleton while loading
  if (loading || !data) {
    return <BasicInfoSkeleton />;
  }

  return (
    <Card sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography fontSize={13} color="#6E6D81" mb={2}>
        Add your technical skills.
      </Typography>

      <Formik
        enableReinitialize
        initialValues={{
          skills:
            Array.isArray(data?.SkillArr) && data.SkillArr.length > 0
              ? data.SkillArr.map((s) => s.title)
              : [""],
        }}
        validationSchema={SkillsSchema}
        onSubmit={async (values) => {
          const skillArr = values.skills
            .filter((s) => s.trim() !== "")
            .map((s) => ({
              title: s,
              proficiency: "Intermediate", // default
            }));

          const payload = {
            ...data,
            SkillArr: skillArr,
          };

          try {
            // SAVE TO DB
             console.log("Saving Skills:", values.skills,payload);
            await saveResumeData(payload);

            // UPDATE CONTEXT
            setData((prev) => ({
              ...prev,
              SkillArr: skillArr,
            }));
          } catch (err) {
            console.error("SKILLS SAVE ERROR:", err);
          }
        }}
      >
        {({ values, handleChange, errors, touched }) => (
          <Form>
            <FieldArray name="skills">
              {({ push, remove }) => (
                <Box>
                  {values.skills.map((skill, idx) => (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      key={idx}
                      sx={{ mb: 1 }}
                    >
                      <Grid size={{ xs: 12, sm: 10 }}>
                        <TextField
                          fullWidth
                          label={`Skill #${idx + 1}`}
                          name={`skills[${idx}]`}
                          size="small"
                          value={skill}
                          onChange={handleChange}
                          error={
                            touched.skills?.[idx] &&
                            Boolean(errors.skills?.[idx])
                          }
                          helperText={
                            touched.skills?.[idx] &&
                            errors.skills?.[idx]
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 2 }} textAlign="right">
                        <IconButton
                          onClick={() => remove(idx)}
                          disabled={values.skills.length === 1}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <Box mt={1}>
                    <Button
                      startIcon={<AddIcon />}
                      onClick={() => push("")}
                    >
                      Add skill
                    </Button>
                  </Box>
                </Box>
              )}
            </FieldArray>

            {/* BUTTONS */}
            <Box mt={3} display="flex" justifyContent="center" gap={4}>
              {/* NEXT */}
              <GradientButton
                type="button"
                onClick={onNext}
              >
                Next
              </GradientButton>

              {/* SAVE */}
              <GradientButton type="submit">
                Save
              </GradientButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
